import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
} from "@/components/ui/alert-dialog";
import { AlertTriangle } from "lucide-react";

export default function ConfirmDialog({
  open,
  onOpenChange,
  title = "Bist du sicher?",
  description = "",
  confirmLabel = "Bestätigen",
  cancelLabel = "Abbrechen",
  danger = false,
  onConfirm,
  testid = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid={testid}
        className="dark border-fundio-line bg-fundio-surface text-fundio-cream"
      >
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2 font-heading text-fundio-cream">
            {danger && <AlertTriangle size={18} className="text-red-400" />} {title}
          </AlertDialogTitle>
          {description && (
            <AlertDialogDescription className="text-fundio-cream/65">
              {description}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <button
            data-testid={`${testid}-cancel`}
            onClick={() => onOpenChange(false)}
            className="rounded-lg border border-fundio-line px-4 py-2.5 text-sm font-medium text-fundio-cream/80 hover:bg-fundio-dark"
          >
            {cancelLabel}
          </button>
          <button
            data-testid={`${testid}-confirm`}
            onClick={() => { onConfirm?.(); onOpenChange(false); }}
            className={`rounded-lg px-4 py-2.5 text-sm font-medium ${
              danger
                ? "bg-red-500/90 text-white hover:bg-red-500"
                : "bg-fundio-gold text-fundio-dark hover:bg-fundio-gold-hover"
            }`}
          >
            {confirmLabel}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
